import AnswerConfirmEdit from './AnswerConfirmEdit';
import AnswerContainer from './AnswerContainer';
import AnswerMediaInput from './AnswerMediaInput';
import AnswerMediaPreview from './AnswerMediaPreview';
import { AnswerMoreOptions } from './AnswerMoreOptions';
import AnswerTextInput from './AnswerTextInput';
import AnswerTextPreview from './AnswerTextPreview';

export const Answer = Object.assign(AnswerContainer, {
  MoreOptions: AnswerMoreOptions,
  ConfirmEdit: AnswerConfirmEdit,
  TextPreview: AnswerTextPreview,
  TextInput: AnswerTextInput,
  MediaPreview: AnswerMediaPreview,
  MediaInput: AnswerMediaInput,
});
